export default function GA(...args) {
  if (process.env.NODE_ENV !== 'production') {
    return
  }
  if (typeof window.ga !== 'function') {
    let retry = 0
    const interval = setInterval(() => {
      if (typeof window.ga === 'function') {
        clearInterval(interval)
        window.ga(...args)
      } else if (retry === 5) {
        clearInterval(interval)
      } else {
        retry += 1
      }
    }, 750)
  } else {
    window.ga(...args)
  }
}

export function pageview(pathname) {
  GA('set', 'page', pathname)
  GA('send', 'pageview')
}

export function event(category, action, label, value) {
  GA('send', {
    hitType: 'event',
    eventCategory: category,
    eventAction: action,
    eventLabel: label,
    eventValue: value,
  })
}

export function timing(timingCategory, timingVar, timingValue) {
  GA('send', {
    hitType: 'timing',
    timingCategory,
    timingVar,
    timingValue,
  })
}

export function user(userId) {
  GA('set', 'userId', userId)
}

export function conversion(name, email) {
  if (process.env.NODE_ENV !== 'production') {
    return
  }
  if (typeof window.goog_report_conversion === 'function') {
    window.goog_report_conversion()
  }
  if (typeof window.fbq === 'function') {
    window.fbq('track', 'CompleteRegistration', {
      name,
      email,
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/ga.js